export enum FileTypes {
    XLS = 'XLS',
    XLSX = 'XLSX',
    CSV = 'CSV',
    PDF = 'PDF',
    TXT = 'TXT',
    JPG = 'JPG',
    JPEG = 'JPEG',
    PNG = 'PNG',
    TIFF = 'TIFF',
    TIF = 'TIF',
    DOC = 'DOC',
    DOCX = 'DOCX',
}

export const getFileExtensionFromMime = (mimeType: string | null | undefined): string | null => {
    if (!mimeType) return null;

    const parts = mimeType.split('/');
    if (parts.length < 2) return null;

    const subtype = parts[1];
    return subtype.split('+')[0].toLowerCase();
};
